import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';
import numeral from 'numeral';
import Tooltip from 'components/Tooltip';

export default createReactClass({
  propTypes: {
    rowKey: PropTypes.number,
    icons: ImmutablePropTypes.iterable,
    size: PropTypes.number,
    options: PropTypes.object,
    workingSetIcons: ImmutablePropTypes.listOf(
      ImmutablePropTypes.record
    ),
    iconSetIdsInSubscription: ImmutablePropTypes.listOf(
      PropTypes.number
    ),
    iconSetsByIconId: ImmutablePropTypes.map,
    onIconSelected: PropTypes.func.isRequired,
    onIconDeselected: PropTypes.func.isRequired,
    onRequestToBuy: PropTypes.func.isRequired,
    onRequestToUpgrade: PropTypes.func.isRequired,
  },

  mixins: [ImmutableRenderMixin],

  getInitialState() {
    return {
      focused: null,
    };
  },

  handleIconFocused(icon) {
    this.setState({
      focused: icon,
    });
  },

  render() {
    const {rowKey, icons, size, options, workingSetIcons, iconSetsByIconId, iconSetIdsInSubscription, onIconSelected, onIconDeselected} = this.props;
    const inWorkingSet = workingSetIcons.map((workingSetIcon) => {
      return workingSetIcon.icon;
    });
    const makeAddRemoveTooltip = (iconName, iconSetName, active) => {
      const popoverProps = (active) ?
        {content: `Remove ${iconName}`, icon: 'ficon-times-circle'} :
        {content: `Add ${iconName}`, icon: 'ficon-plus-circle'};
      if (options.addIconSetName) {
        popoverProps.details = `(${iconSetName})`;
      }
      return <Tooltip {...popoverProps} />;
    };
    const makeBuyTooltip = (iconName, iconSetName, iconSetPrice) => {
      return <Tooltip content={`Buy ${iconSetName} ${numeral(iconSetPrice).format('$0')}`} details={`(${iconName})`} icon="ficon-dollar-circle" />;
    };
    const makeUpgradeTooltip = (iconName, iconSetName) => {
      return <Tooltip content={`Upgrade to use ${iconSetName}`} details={`(${iconName})`} icon="ficon-level-up-circle" />;
    };
    const highlightedIconName = (icon) => {
      return options.highlightedIconNames.get(icon.id, icon.name);
    };

    const iconElements = icons
      .map((icon, index) => {
        const iconSet = iconSetsByIconId.get(icon.id);
        const active = inWorkingSet.includes(icon.id);
        const aClassName = classnames(
          'icon',
          {active},
          {'show-add': (this.state.focused === icon)},
          {'unavailable': !iconSetIdsInSubscription.includes(iconSet.id)},
        );
        const iconClassName = classnames(
          `icon-set-preview-icon`,
          `icon-set-preview-${size}-${iconSet.slug}`,
          `icon-set-preview-${size}-${iconSet.slug}-${icon.name}`
        );

        let onClicked = () => {};
        let popover = null;

        if (this.state.focused === icon) {
          if (iconSetIdsInSubscription.includes(iconSet.get('id'))) {
            onClicked = (event) => {
              event.preventDefault();
              ((active) ? onIconDeselected : onIconSelected)(iconSet.token, icon.id, icon.name);
            };
            popover = makeAddRemoveTooltip(highlightedIconName(icon), iconSet.name, active);
          } else if (iconSet.price > 0) {
            onClicked = (event) => {
              event.preventDefault();

              this.props.onRequestToBuy(iconSet);
            };
            popover = makeBuyTooltip(highlightedIconName(icon), iconSet.name, iconSet.price);
          } else {
            onClicked = (event) => {
              event.preventDefault();

              this.props.onRequestToUpgrade();
            };
            popover = makeUpgradeTooltip(highlightedIconName(icon), iconSet.name);
          }
        }

        return (
          <a key={`${rowKey}-${index}`} onMouseOver={() => (this.handleIconFocused(icon))} onMouseOut={this.handleIconFocused} className={aClassName} onClick={onClicked} href="#">
            {popover}
            <i className={iconClassName}></i>
          </a>
        );
      });

    return (
      <div>{iconElements}</div>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/IconRow.js